import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'


function DeleteEje(props) {
	const { eje, mostrar, setQueMostrar, eliminarEje } = props

	const handleClose = () => {
		setQueMostrar('')
	}
	
	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar eje</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					Está a punto de eliminar el eje <strong>{`${eje.nombre}`}</strong>. Esta acción no se puede deshacer.
				</Alert>
				<p>¿Está seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-tertiary" onClick={handleClose}>
					Cancelar
				</Button>
				<Button variant="primary" onClick={() => eliminarEje(eje.id)}>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default DeleteEje